<template>
  <div class="content">
    <board-tools
      v-model="drawData"
      :hide-send="white"
      @clearboard="clearCanvas()"
      @sendimg="sendImg()"
      @usebrush="useBrush()"
      @useeraser="useEraser()"
    />
    <drawing-board-vue
      v-loading="loading"
      ref="board"
      v-model="drawingCanvas"
      :color="drawData.brushColor"
      :size="drawData.brushSize"
      board-id="board"
      height="85vh"
      width="100%"
      @drawing="startedDrawing()"
    />
    <page-footer />
  </div>
</template>

<script>
import { Cloudinary } from "@nodopiano/vue-drawingboard";
import Translation from "../translation.js";
import Config from "../config.js";
import idleJs from "idle-js";

export default {
  data() {
    return {
      drawingCanvas: "",
      drawData: {
        brushSize: 6,
        brushColor: "rgba(0, 0, 0, 1)",
        isEraser: false,
        lang: "IT",
        sendDesc: "",
        sendFrom: "",
        sendTitle: ""
      },
      idle: null,
      loading: false,
      white: true
    };
  },

  mounted: function() {
    this.idle = new idleJs({
      idle: 600000,
      events: ["mousemove", "keydown", "mousedown", "touchstart"],
      onIdle: () => {
        this.reset();
      },
      onActive: function() {},
      onHide: function() {},
      onShow: function() {},
      keepTracking: true,
      startAtIdle: false
    });

    this.idle.start();
  },

  methods: {
    clearCanvas: function() {
      this.white = true;
      this.$refs.board.clearBoard();
    },
    sendImg: function() {
      this.loading = true;
      Cloudinary.upload(
        this.drawingCanvas,
        Config.cloudinary.cloudName,
        Config.cloudinary.uploadPreset,
        [this.drawData.lang],
        {
          alt: this.drawData.sendDesc,
          caption: this.drawData.sendTitle,
          provenienza: this.drawData.sendFrom
        }
      )
        .then(() => {
          this.reset();
          this.$message.success(Translation.sent[this.drawData.lang]);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    reset: function() {
      this.drawData.sendTitle = "";
      this.drawData.sendDesc = "";
      this.drawData.brushColor = "#000000";
      this.drawData.brushSize = 6;
      this.loading = false;
      this.clearCanvas();
    },
    startedDrawing: function() {
      this.white = false;
    },
    useBrush: function() {
      this.$refs.board.useBrush();
      this.drawData.isEraser = false;
    },
    useEraser: function() {
      this.$refs.board.useEraser();
      this.drawData.isEraser = true;
    }
  }
};
</script>

<style lang="scss">
</style>
